exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".waitlist-form .notify-text[data-v-12caf290] {\n  margin-bottom: 1em;\n}\n.waitlist-form .email-input[data-v-12caf290],\n.waitlist-form .submit-btn[data-v-12caf290] {\n  display: inline-block;\n  vertical-align: top;\n}\n.waitlist-form .email-input[data-v-12caf290] {\n  width: 65%;\n  margin-right: 0.5em;\n  margin-top: 0;\n}\n.waitlist-form .submit-btn[data-v-12caf290] {\n  width: 30%;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  padding-top: 0.8em;\n  height: 44px;\n}\n", ""]);

// exports
